import styled from 'styled-components';

import { BRAND_DEPLOYMENT_ARROW, BRAND_DEPLOYMENT_ANIM, REDUCED_MOTION } from '../../../../../theme/tokens';

/** Compact frosted control holding the two chevrons with a slim separator between them.
 *  Rendered in the section header's top-right corner (see BrandDeploymentStrip). */
export const Nav = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  border: 1px solid ${BRAND_DEPLOYMENT_ARROW.border};
  background: ${BRAND_DEPLOYMENT_ARROW.bg};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
`;

/** One chevron button — a transparent glyph tap target inside the pill. */
export const Arrow = styled.button`
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: ${BRAND_DEPLOYMENT_ARROW.glyph};
  cursor: pointer;
  transition:
    opacity ${BRAND_DEPLOYMENT_ANIM.HOVER_MS}ms ease,
    transform ${BRAND_DEPLOYMENT_ANIM.LINK_MS}ms ease;

  & > svg {
    width: 16px;
    height: 16px;
  }

  &:hover:not([aria-disabled='true']) {
    transform: scale(1.14);
  }

  &:focus-visible {
    outline: 2px solid ${BRAND_DEPLOYMENT_ARROW.glyph};
    outline-offset: 2px;
  }

  /* aria-disabled (not the native disabled attribute) so the button stays focusable —
     at an edge it reads disabled (dimmed + inert) rather than vanishing. */
  &[aria-disabled='true'] {
    opacity: 0.32;
    cursor: default;
    pointer-events: none;
  }

  ${REDUCED_MOTION} {
    transition: opacity ${BRAND_DEPLOYMENT_ANIM.HOVER_MS}ms ease;

    &:hover:not([aria-disabled='true']) {
      transform: none;
    }
  }
`;

/** Slim vertical separator between the two chevrons (in place of the old position bullets):
 *  a short 1px rule in the pill's neutral marker tone. */
export const Divider = styled.span`
  width: 1px;
  height: 16px;
  border-radius: 1px;
  background: ${BRAND_DEPLOYMENT_ARROW.dot};
`;
